import { Link } from "react-router-dom";
import { CATEGORIES } from "@/mocks/anime";

export default function Footer() {
  const quickLinks = [
    { label: "首页", to: "/" },
    { label: "番剧库", to: "/library" },
    { label: "关于我们", to: "/about" },
  ];

  return (
    <footer className="relative mt-0 bg-gradient-to-b from-primary-950 via-primary-900 to-[oklch(var(--background-50))] border-t border-primary-800/40">
      <div className="mx-auto max-w-7xl px-4 md:px-6 pt-14 pb-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <span className="relative flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-950">
                <i className="ri-heart-2-fill text-lg" />
              </span>
              <span className="font-heading text-xl tracking-wide text-foreground-950">
                樱花看番
              </span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              樱花看番番剧库全收录，动画、剧场版、OVA、泡面番与国漫全类型。点开即看全集，找番更方便。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a
                href="#"
                rel="nofollow noopener"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-800/60 text-foreground-500 transition-colors hover:bg-primary-500 hover:text-background-950"
                aria-label="微博"
              >
                <i className="ri-weibo-line" />
              </a>
              <a
                href="#"
                rel="nofollow noopener"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-800/60 text-foreground-500 transition-colors hover:bg-primary-500 hover:text-background-950"
                aria-label="哔哩哔哩"
              >
                <i className="ri-bilibili-line" />
              </a>
              <a
                href="#"
                rel="nofollow noopener"
                className="flex h-9 w-9 items-center justify-center rounded-full bg-background-800/60 text-foreground-500 transition-colors hover:bg-primary-500 hover:text-background-950"
                aria-label="豆瓣"
              >
                <i className="ri-douban-line" />
              </a>
            </div>
          </div>

          {/* quick links */}
          <div>
            <h4 className="font-heading text-base text-foreground-950">快速导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              {quickLinks.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="transition-colors hover:text-primary-300">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* categories */}
          <div>
            <h4 className="font-heading text-base text-foreground-950">番剧类型</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              {CATEGORIES.filter((c) => c.key !== "all").map((c) => (
                <li key={c.key}>
                  <Link
                    to={`/library?cat=${encodeURIComponent(c.key)}`}
                    className="transition-colors hover:text-primary-300"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* contact */}
          <div>
            <h4 className="font-heading text-base text-foreground-950">联系我们</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line" />
                contact@sakura-kankan.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line" />
                樱花看番官方公众号
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line" />
                新番每周五更新
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-primary-800/40 pt-6 text-xs text-foreground-600">
          <p>© {new Date().getFullYear()} 樱花看番 Sakura Kankan · 番剧库全收录</p>
          <p className="flex items-center gap-1">
            <i className="ri-heart-3-line text-primary-400" /> 为热爱动漫的你而生
          </p>
        </div>
      </div>
    </footer>
  );
}